

if (typeof window.getComputedStyle(document.body).mixBlendMode === 'undefined') {
    document.documentElement.classList.add('mix-blend-alternative')
}

document.addEventListener('scroll', function () {
    let header;
    if (header = document.querySelector('header.main-header')) {
        let bounding = header.getBoundingClientRect();

        if (!header.classList.contains('sticky')) {
            if (bounding.top <= 0) header.classList.add('sticky')
        } else {
            if( bounding.bottom >= 82) header.classList.remove('sticky')
        }
    }
});

export default function mobileNavigation( ev ) {
    if( matchMedia( '(min-width: 1440px)' ).matches ) return;
    if( ev.currentTarget.classList.contains('active') ) return closeMobileMenu( ev.currentTarget );
     return openMobileMenu( ev.currentTarget );
}

function openMobileMenu( hamburger ) {
    hamburger.classList.add( 'active' )
    let menu = document.querySelector( 'nav.main-navigation' )
    menu.style.display = 'block'
    setTimeout( () => { menu.classList.add( 'active' ) }, 2 )
    document
        .querySelectorAll('nav.main-navigation .has-dropdown .menu-item')
        .forEach( el => { el.addEventListener( 'click', toggleMobileDropdowns ) } )
}

function closeMobileMenu( hamburger ) {
    hamburger.classList.remove( 'active' )
    let menu = document.querySelector( 'nav.main-navigation' )
    menu.classList.remove( 'active' )
    setTimeout( () => { menu.style.display = 'none' }, 400 )
    document
        .querySelectorAll('nav.main-navigation .has-dropdown .menu-item')
        .forEach( el => { el.removeEventListener( 'click', toggleMobileDropdowns ) } )
}

function toggleMobileDropdowns( ev ) {
    let dropdowns = document.querySelectorAll('nav.main-navigation .has-dropdown .menu-item')
    dropdowns.forEach( el => { el.parentNode.classList.remove('active') } )
    ev.currentTarget.parentNode.classList.toggle('active')
}
